<template lang="pug">
AppDialog(
  title="Add to my calendar"
  show
  append-to-body
  @close="closeDialog"
)
  template(slot="corner")
    a.dialog-faq-link(
      target="_blank"
      rel="noopener noreferrer"
      title="View our support article with specific calendar steps"
      :href="supportURL"
    ) ?
  .dialog-body
    span You can add this schedule view to Google Calendar, Outlook, Apple Calendar, and other calendar apps.
    .row.margin-top(v-if="!instructionsVisible")
      .col-sm-12
        a.strong.cursor-pointer(@click="toggleInstructions") View instructions
    #instructions.row.margin-top(v-else)
      div
        .col-sm-12
          .row.mb-5
            .col-xs-6
              span.strong Instructions:
            .col-xs-6
              .pull-right.cursor-pointer
                a.strong(@click="toggleInstructions") Hide instructions
          .row
            .col-sm-12
              span
                | 1) Copy the URL below
                br
                | 2) Open your calendar app
                br
                | 3) Find the option to add a calendar via a URL

          .row.margin-top
            .col-sm-12
              span
                | Need more help? View our&nbsp;
                a.dialog-faq-link(
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="supportURL"
                )
                  | support article
                | &nbsp;with specific calendar steps.
    .row.margin-top
      .col-sm-12
        AppCopyInputValue(:value="attendanceIcalendarURL")
    .row.mt-5(v-if="hasFilters")
      .col-sm-12
        .filters
          | This Calendar URL has {{ filtersApplied }}&nbsp;
          span
            | applied
            i.hi.hi-info-filled.hi-14.ml-5(
              v-tooltip="true"
              :data-original-title="filterDescription"
            )

  template(slot="footer")
    button.btn.btn-default(@click="closeDialog") Close
</template>

<script>
import { mapInertiaProps } from '~/utils/inertia';
import { pluralize } from '~/utils/string_utils';

export default {
  name: 'IcalendarDialog',
  data: () => ({
    instructionsVisible: false,
    btnText: 'Copy',
    supportURL: 'https://support.hubstaff.com/sync-team-schedules-to-calendar/',
  }),
  computed: {
    ...mapInertiaProps({
      attendanceIcalendarURL: 'attendanceIcalendarURL',
      userIds: 'filtered_user_ids',
      eventsFilter: 'events_filter',
      teamIds: 'filtered_team_ids',
    }),
    attendanceIcalendarMembersCount() {
      return this.userIds.filter((item) => !isNaN(item)).length;
    },
    attendanceIcalendarTeamsCount() {
      return this.teamIds.filter((item) => !isNaN(item)).length;
    },
    attendanceIcalendarEventsCount() {
      return this.eventsFilter.length;
    },
    totalFilters() {
      return (
        this.attendanceIcalendarMembersCount + this.attendanceIcalendarTeamsCount + this.attendanceIcalendarEventsCount
      );
    },
    hasFilters() {
      return this.totalFilters > 0;
    },
    filterDescription() {
      const filterDescription = [];

      if (this.attendanceIcalendarMembersCount > 0) {
        filterDescription.push(`Members (${this.attendanceIcalendarMembersCount})`);
      }

      if (this.attendanceIcalendarTeamsCount > 0) {
        filterDescription.push(`Teams (${this.attendanceIcalendarTeamsCount})`);
      }

      if (this.attendanceIcalendarEventsCount > 0) {
        filterDescription.push(`Events (${this.attendanceIcalendarEventsCount})`);
      }

      return filterDescription.join(', ');
    },
    filtersApplied() {
      return `${this.totalFilters} ${pluralize(this.totalFilters, 'filter', 'filters')}`;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    toggleInstructions() {
      this.instructionsVisible = !this.instructionsVisible;
    },
  },
};
</script>
